import { useEffect, useState } from 'react';

export const useScript = (src: string, async = false) => {
  const [status, setStatus] = useState<'loading' | 'ready' | 'error' | 'idle'>('idle');

  useEffect(() => {
    if (!src) {
      setStatus('idle');
      return;
    }

    setStatus('loading');

    const script = document.createElement('script');
    script.src = src;
    script.type = 'text/javascript';
    script.async = async;

    const handleLoad = () => setStatus('ready');
    const handleError = () => setStatus('error');

    script.addEventListener('load', handleLoad);
    script.addEventListener('error', handleError);

    document.head.appendChild(script);

    return () => {
      script.removeEventListener('load', handleLoad);
      script.removeEventListener('error', handleError);
    };
  }, [src, async]);

  return status;
};
